import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import styled from "styled-components";
import DashboardSidebarMenu from "../components/DashboardSidebarMenu.tsx";

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;

  height: 100vh; //100%
  background-color: #f9f9f9;
`;

const Content = styled.div<{ $isMenuOpen: boolean }>`
  flex-grow: 1;
  height: 100%;
  background-color: #f9f9f9;

  transition: margin-left 0.3s ease;
  ${({ $isMenuOpen }) => ($isMenuOpen ? "margin-left: -165px;" : "")};
  display: flex;
  flex-direction: column;
  align-items: center;

  & > div {
    height: 100%;
  }
`;

const DashboardLayout = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isMenuClosed, setIsMenuClosed] = useState(false);

  const checkScreenSize = () => {
    // Use matchMedia to check for mobile screen size
    setIsMobile(window.matchMedia("(max-width: 820px)").matches);
  };

  useEffect(() => {
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  return (
    <Wrapper data-testid="dashboard-layout">
      <DashboardSidebarMenu toggleMenu={setIsMenuClosed} />

      <Content $isMenuOpen={isMenuClosed} data-testid="content">
        <Outlet />
      </Content>
    </Wrapper>
  );
};

export default DashboardLayout;
